import RouteElement from "./Routes";
import "./App.css";
import { useCallback, useEffect, useState } from "react";

import UserContext, { useUser, useSetUser } from "./context/userContext.js";

import { refreshUser } from "./api/axios.js";

import { toast, ToastContainer } from "react-toastify";

// Import toastify css file
import "react-toastify/dist/ReactToastify.css";

const App = () => {
  const setUser = useSetUser();

  const [done, setDone] = useState(false);
  const initialize = useCallback(() => {
    console.log(localStorage.getItem("refreshToken"));
    refreshUser(localStorage.getItem("refreshToken"))
      .then((response) => {
        setUser(response.data);
        localStorage.getItem("refreshToken");
        toast("welcome back " + response.data.user.username + "!!!!!");
      })

      .catch((e) => {
        //do nothing
      })
      .finally(() => {
        setDone(true);
      });
  }, []);
  useEffect(() => {
    initialize();
  }, []);

  return (
    <div className="relative">
      <ToastContainer />
      {done && <RouteElement />}
    </div>
  );
};

export default App;
